import { ActionIcon } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Rnd } from 'react-rnd';

import { PlanToIfcWorkspace } from 'app/modules/wallforming/components/plan-to-ifc/PlanToIfcWorkspace';

const dialogWidth = 520;
const dialogHeight = 600;

type PlanToIfcDialogProps = {
    onClose: () => void;
};

/** Draggable workspace window around the shared plan-to-IFC flow. */
export const PlanToIfcDialog = ({ onClose }: PlanToIfcDialogProps) => {
    const { t } = useTranslation();

    return (
        <div
            style={{
                height: '100vh',
                left: 0,
                pointerEvents: 'none',
                position: 'fixed',
                top: 0,
                width: '100vw',
                zIndex: 9999
            }}
            onClick={(e) => e.stopPropagation()}
            onPointerDown={(e) => e.stopPropagation()}
            onPointerMove={(e) => e.stopPropagation()}
            onPointerUp={(e) => e.stopPropagation()}
        >
            <Rnd
                bounds="window"
                default={{
                    x: Math.max((window.innerWidth - dialogWidth) / 2, 0),
                    y: Math.max((window.innerHeight - dialogHeight) / 2, 0),
                    width: dialogWidth,
                    height: dialogHeight
                }}
                dragHandleClassName="rnd-drag-handle"
                enableResizing={false}
                enableUserSelectHack={false}
                size={{ width: dialogWidth, height: dialogHeight }}
                style={{ pointerEvents: 'auto' }}
            >
                <div
                    className="flex flex-col overflow-hidden rounded-md border border-border-light bg-background-default text-text-default shadow-lg"
                    data-testid="plan-to-ifc-dialog"
                    style={{ height: dialogHeight, width: dialogWidth }}
                >
                    <div className="rnd-drag-handle flex cursor-move select-none items-center justify-between border-b border-border-light bg-background-gray-ultra-light px-3 py-2">
                        <span className="text-sm font-semibold">{t('labelGenerateIfcFromPdfs')}</span>
                        <ActionIcon
                            aria-label={t('close')}
                            className="action-icon-small bg-transparent hover:bg-background-gray! pointer-events-auto icon-sm"
                            onClick={onClose}
                            onPointerDown={(e) => e.stopPropagation()}
                        >
                            close
                        </ActionIcon>
                    </div>
                    <div className="min-h-0 flex-1 overflow-auto p-3">
                        <PlanToIfcWorkspace onLeave={onClose} />
                    </div>
                </div>
            </Rnd>
        </div>
    );
};
